import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-529a347c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "环境参数", -1))
const _hoisted_3 = {
  key: 0,
  class: "container-text"
}
const _hoisted_4 = { class: "chart-box" }
const _hoisted_5 = {
  key: 1,
  class: "no-data",
  height: "100%",
  width: "100%"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "该空间数据未配置", -1))
const _hoisted_10 = { class: "detail-desc clearfix" }
const _hoisted_11 = { class: "detail-text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle" }, null, -1))
const _hoisted_13 = { class: "tem-span" }
const _hoisted_14 = { class: "detail-bottom" }
const _hoisted_15 = { class: "text-img" }
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_com_chart = _resolveComponent("com-chart")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_tabs, {
      class: "my-tab",
      onChange: _ctx.changeTab,
      active: _ctx.active,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            title: item.name,
            name: item.funcid,
            key: item.id + '' + index
          }, {
            default: _withCtx(() => [
              (item.options)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(item.funcid == "Tdb,RH" ? "温湿度逐时分布" : "浓度逐时分布"), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (item.options)
                  ? (_openBlock(), _createBlock(_component_com_chart, {
                      key: 0,
                      options: item.options,
                      id: item.funcid,
                      height: "100%",
                      width: "100%"
                    }, null, 8, ["options", "id"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (item.showNowData === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("img", {
                              src: _ctx.parseImgUrl('page-officehome', 'empty.png'),
                              alt: ""
                            }, null, 8, _hoisted_6),
                            _hoisted_7
                          ], 64))
                        : _createCommentVNode("", true),
                      (item.showNowData === 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("img", {
                              src: _ctx.parseImgUrl('page-officehome', 'empty.png'),
                              alt: ""
                            }, null, 8, _hoisted_8),
                            _hoisted_9
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (textItem, idx) => {
                    return (_openBlock(), _createElementBlock("p", { key: idx }, [
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, _toDisplayString(textItem), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", null, _toDisplayString(item.level), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: ""
                  }, null, 8, _hoisted_16)
                ])
              ])
            ]),
            _: 2
          }, 1032, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onChange", "active"]),
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_van_loading, {
          key: 0,
          class: "temp-loading"
        }))
      : _createCommentVNode("", true)
  ]))
}